/**
 * Runtime URL-prefix detection — makes the same `dist/` build work whether it
 * is served at `/app/` (local dev), `/ukv-payroll/app/` (prod under Apache
 * with ProxyPass), or any other path-prefix. No environment variables, no
 * separate per-env builds.
 *
 *   /ukv-payroll/app/employees   →  prefix = "/ukv-payroll"
 *   /app/employees               →  prefix = ""
 *   /                            →  prefix = ""   (defensive — pre-mount)
 *
 * The OpenAPI client and any fetch wrapper consume `API_BASE`. UI code that
 * needs to construct in-app URLs uses `APP_BASE`.
 */
function detectPrefix(): string {
  if (typeof window === 'undefined') return '';
  const m = window.location.pathname.match(/^(.*?)\/app(\/|$)/);
  return m ? m[1]! : '';
}

export const URL_PREFIX = detectPrefix();
export const API_BASE   = `${URL_PREFIX}/api`;
export const APP_BASE   = `${URL_PREFIX}/app`;

// Surface for debugging in the console.
if (typeof window !== 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).__UKN__ = { URL_PREFIX, API_BASE, APP_BASE };
}
